export default __webpack_public_path__ + "static/menu_bg-4c02d291bad0daf10158cc1030ed982a.mp4";